<div *ngIf="item" appCollapsible>
  <div class="item" (tap)="toggleSelection($event)" [class.selected]="item.selected" [class.interactive]="votingControl.submissionMode">
    <div class="content">
      <img class="icon" *ngIf="item.pictures.length"
           [src]="item.pictures | firstImageUrl" [alt]="item.title">
      <div appCollapsibleHeader *ngIf="item.rating != null"
           class="rating" #rating
           (click)="showItemDetails($event)">
        <span class="value">{{item.rating | number: '1.1-1' : 'en-US'}}</span>
        <span class="label">Punkte</span>
      </div>
      <div class="info">
        <div class="title-container">
          <span class="title" [innerHTML]="item.title"></span>
          <span *ngIf="votingControl.submissionMode && item.subtitle" class="subtitle">{{item.subtitle | uppercase}}</span>
        </div>
        <div *ngIf="votingControl.resultsMode" class="voting-result" #votingResult>
          <div class="result-indicator"></div>
          <span class="bar" [ngStyle]="{'width': ratioSectionMax * 100 + '%'}"></span>
          <div class="percentage-knob" [ngStyle]="{'left': 'max(0px, calc(' + ratioSectionMax * 100 + '%' + ' - 3em))'}">
            <span class="percentage">{{ratioSectionTotal * 100 | number: '1.1-1'}}%</span>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="votingControl.submissionMode" #selectionStatus class="selection-status">
      <span *ngIf="item.selected; else circle" class="material-icons checkbox">check_circle_outline</span>
      <ng-template #circle>
        <span class="material-icons circle">radio_button_unchecked</span>
      </ng-template>
    </div>
  </div>
  <div appCollapsibleContent *ngIf="detailData" class="detail-content">
    <app-voting-player-event-rating *ngIf="detailData" [eventRating]="detailData"></app-voting-player-event-rating>
  </div>
</div>
